import React from "react";
import { Box } from "@chakra-ui/react";

export const DragDropIcon = (props) => {
  return (
    <Box {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="#424770"
        viewBox="0 0 32 32"
        width="22px"
        height="22px"
      >
        <path d="M 16 5 L 12 9 L 20 9 Z M 3 11 L 3 13 L 29 13 L 29 11 Z M 3 15 L 3 17 L 29 17 L 29 15 Z M 3 19 L 3 21 L 29 21 L 29 19 Z M 12 23 L 16 27 L 20 23 Z" />
      </svg>
    </Box>
  );
};
